module.exports = __webpack_public_path__ + "img/OpenSans-SemiBoldItalic.7f45685d.svg";